export const primaryColumnFields//: ColumnFilterFields[]
 = [
  {id: "selected", label: "Select", type: "boolean", disabled: true, hidden: false },
  { id: "Status", label: "Status", type: "string", disabled: true, hidden: false },
  { id: "ID", label: "Id", type: "string",  disabled: true, hidden: false },
  { id: "User", label: "User", type: "string",  disabled: false, hidden: true },
  { id: "Date", label: "Date", type: "date", disabled: false, hidden: false },
  { id: "Supplier", label: "Supplier", type: "string", disabled: false, hidden: false },
  { id: "Category", label: "Category", type: "string", disabled: false, hidden: false },
  { id: "Total", label: "Total", type: "number", disabled: false, hidden: false },
  { id: "Tax", label: "Tax", type: "number", disabled: false, hidden: false },
  

  { id: "Taxrate", label: "Tax Rate", type: "number", disabled: true, hidden: false },
  { id: "Match", label: "Match", type: "number", disabled: true, hidden: false },

  //{ id: "Submitted By", label: "Submitted By", type: "string", disabled: false, hidden: false },
  { id: "Due Date", label: "Due Date", type: "date", disabled: false, hidden: true },
  { id: "Document Ref", label: "Document Ref", type: "string", disabled: false, hidden: true },
  { id: "Base Total", label: "Base Total", type: "number", disabled: false, hidden: true },
  { id: "Description", label: "Description", type: "string", disabled: false, hidden: true },
  { id: "Paid", label: "Paid", type: "boolean", disabled: false, hidden: true },
  { id: "Payment", label: "Payment", type: "string", disabled: false, hidden: true },
  { id: "Type", label: "Type", type: "string", disabled: false, hidden: true },
  { id: "Item ID", label: "Item ID", type: "string", disabled: false, hidden: true },
  { id: "PaymentMethod", label: "Submission Method", type: "string", disabled: false, hidden: true },
  { id: "Note / Message", label: "Note / Message", type: "string", disabled: false, hidden: true },
  { id: "Upload Date", label: "Upload Date", type: "date", disabled: false, hidden: true },
  { id: "Export Date", label: "Export Date", type: "date", disabled: false, hidden: true },
];


export const additionalColumnFields//: ColumnFilterFields[] 
= [
  { id: "Submitted By", label: "Submitted By", type: "string", disabled: false, hidden: false },
  { id: "Due Date", label: "Due Date", type: "date", disabled: false, hidden: false },
  { id: "Document Ref", label: "Document Ref", type: "string", disabled: false, hidden: false },
  { id: "baseTotal", label: "Base Total", type: "number", disabled: true, hidden: false },
  { id: "Description", label: "Description", type: "string", disabled: false, hidden: false },
  { id: "Paid", label: "Paid", type: "string", disabled: false, hidden: false },
  { id: "Payment", label: "Payment", type: "string", disabled: false, hidden: false },
  { id: "Type", label: "Type", type: "string", disabled: false, hidden: false },
  { id: "itemId", label: "Item ID", type: "string", disabled: true, hidden: false },
  { id: "Submission Method", label: "Submission Method", type: "string", disabled: false, hidden: false },
  { id: "noteMessage", label: "Note / Message", type: "string", disabled: true, hidden: false },
  { id: "Upload Date", label: "Upload Date", type: "date", disabled: false, hidden: false },
  { id: "exportDate", label: "Export Date", type: "date", disabled: true, hidden: false },
  { id: "Taxrate", label: "Tax Rate", type: "number", disabled: true, hidden: true },
  { id: "Match", label: "Match", type: "number", disabled: true, hidden: true },

  { id: "Payment", label: "Payment", type: "string", disabled: false, hidden: true },
  { id: "exchangeRate", label: "Exchange Rate", type: "number", disabled: false, hidden: true },
  { id: "paymentTerms", label: "Payment Terms", type: "string", disabled: false, hidden: true },
  { id: "projectCode", label: "Project Code", type: "string", disabled: false, hidden: true },
  { id: "costCenter", label: "Cost Center", type: "string", disabled: false, hidden: true },
  { id: "approvalStatus", label: "Approval Status", type: "string", disabled: false, hidden: true },
  { id: "invoiceNumber", label: "Invoice Number", type: "string", disabled: false, hidden: true },
  { id: "vendorCode", label: "Vendor Code", type: "string", disabled: false, hidden: true },
  { id: "taxAmount", label: "Tax Amount", type: "number", disabled: false, hidden: true },
  { id: "lineItems", label: "Line Items", type: "number", disabled: false, hidden: true },
];